import React from "react";
import QuarterlyAwardSummaryTable from "./QuarterlyAwardSummaryTable";
import ReportProgramsPage from "../../components/ReportProgramsPage";

const QuarterlyAwardSummaryIndex = () => (
  <ReportProgramsPage
    TableComponent={QuarterlyAwardSummaryTable}
    loadingMessage="Loading quarterly awards summary..."
  />
);

export default QuarterlyAwardSummaryIndex;
